import React from 'react'
import "./backgroundAnimation.css"
function backgroundAnimation() {
    return (

        <>
         {/* <div class="context">
        <h1>Tech Master Gogo</h1>
    </div> */}
            <ul className="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
            </ul>
    </>
    )
}

export default backgroundAnimation
